import React, { forwardRef, useState } from "react";
import { Text } from "../Text/Text.js";
import { TextSize } from "../Text/Text.types.js";
import { CheckboxWrapper, CheckedIcon, Container, DOMCheckbox, FakeCheckbox, IndeterminateIcon } from "./Checkbox.styles.js";
import { CheckboxProps, DefaultCheckboxProps } from "./Checkbox.types.js";

const defaultProps: DefaultCheckboxProps = {
    indeterminate: false,
    color: "primary",
    size: "medium",
};

export const Checkbox = forwardRef<HTMLLabelElement, CheckboxProps>((props, ref): JSX.Element => {
    const {
        label,
        rightComponent: component,
        disabled,
        checked: checkedProps,
        indeterminate,
        onChange,
        color,
        size,
        status,
        id,
        align = "start",
        ...attributes
    } = { ...defaultProps, ...props };

    const [checkedState, setCheckedState] = useState<boolean>(!!attributes.defaultChecked);

    const isControlled = checkedProps !== undefined;
    const checked = isControlled ? checkedProps : checkedState;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (!isControlled) setCheckedState(e.target.checked);
        onChange?.(e);
    };

    return (
        <Container id={id} ref={ref} disabled={disabled} color={color} align={align}>
            <CheckboxWrapper color={color}>
                <DOMCheckbox
                    {...attributes}
                    $size={size}
                    disabled={disabled}
                    checked={checked}
                    type="checkbox"
                    onChange={handleChange}
                    className={`${attributes.className ?? ""} ${indeterminate ? "indeterminate" : ""}`}
                />

                <FakeCheckbox status={status} size={size}>
                    <CheckedIcon size={size} />
                    <IndeterminateIcon />
                </FakeCheckbox>
            </CheckboxWrapper>

            {label && <Text size={TextSize["X-SMALL"]}>{label}</Text>}
            {component}
        </Container>
    );
});
